import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataServiceConfig,
    EntityCollectionService,
    EntityServices,
    HttpUrlGenerator,
    QueryParams
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Guid } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { entityName as jobTimerEntityName, JobTimerModel } from '../job-timer';
import { IndirectRateReviewModel } from './indirect-rate-review.model';
export const entityName = 'IndirectRateAdjustApply';
@Injectable({ providedIn: 'root' })
export class IndirectRateReviewDataService extends EfaactDataService<IndirectRateReviewModel> {
    private jobName = 'ef_indirectratesadjust_apply';
    private jobTimerDataService: EntityCollectionService<JobTimerModel>;
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store,
        private entityServices: EntityServices
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
        this.jobTimerDataService =
            entityServices.getEntityCollectionService<JobTimerModel>(
                jobTimerEntityName
            );
    }
    mapItems(item: IndirectRateReviewModel): IndirectRateReviewModel {
        return { ...item, id: Guid.newGuid() };
    }
    getWithQuery(
        params: string | QueryParams
    ): Observable<IndirectRateReviewModel[]> {
        // setTimeout(() => {
        //     this.jobTimerDataService.getWithQuery({
        //         Jobdesc: this.jobName
        //     });
        // }, 0);
        return super.getWithQuery(params);
    }
    getAll(): Observable<IndirectRateReviewModel[]> {
        return super.getAll();
    }

    mapGetResponse(resp) {
        this.log.verbose({
            type: `${this.entityName}DataService(IndirectRateReviewDataService):mapResponse:resp`,
            resp
        });
        const result = JSON.parse(resp) as IndirectRateReviewModel[];
        this.log.verbose({
            type: `${this.entityName}DataService(IndirectRateReviewDataService):mapResponse:result`,
            result
        });
        setTimeout(() => {
            this.jobTimerDataService.getWithQuery({
                Jobdesc: sessionStorage.getItem('jobTimerName')//this.jobName
            });
        }, 0);
        if (Array.isArray(result)) {
            return result;
        } else {
            return [] as IndirectRateReviewModel[];
        }
    }
}
